// extracted by mini-css-extract-plugin
export default {"pricingCard":"PricingCard_common_pricingCard__hcf7j","offerPill":"PricingCard_common_offerPill__MHSwI","modulePriceText":"PricingCard_common_modulePriceText__N6GBk"};